var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-inline position-relative menu-extra-dropdown",
      class: {
        "font-weight-normal": _vm.active,
        "font-weight-light": !_vm.active,
        "hover-white": _vm.$root.isMobile && _vm.show
      },
      on: { mouseenter: _vm.toggleOpenHover, mouseleave: _vm.toggleOpenHover }
    },
    [
      _vm.$root.isMobile && _vm.show
        ? _c(
            "span",
            {
              staticClass:
                "d-inline-flex align-items-center mobile-dropdown-label",
              class: { "hover-white": _vm.$root.isMobile },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.toggleOpen($event)
                }
              }
            },
            [_vm._v(_vm._s(_vm.label))]
          )
        : _c(
            "span",
            {
              staticClass: "d-inline-flex align-items-center dropdown-label",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.toggleOpen($event)
                }
              }
            },
            [
              _vm._v(_vm._s(_vm.label)),
              _c("i", {
                staticClass: "ml-8 fas xsmall",
                class: {
                  "fa-caret-down": !_vm.$root.isMobile,
                  "fa-caret-right": _vm.$root.isMobile
                }
              })
            ]
          ),
      _vm._v(" "),
      !_vm.$root.isMobile
        ? _c("slide-y-up-transition", [
            _vm.show
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "click-outside",
                        rawName: "v-click-outside",
                        value: _vm.close,
                        expression: "close"
                      }
                    ],
                    staticClass:
                      "position-absolute dropdown-menu text-left pt-16"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "wrapper" },
                      _vm._l(_vm.visibleLandingPages, function(landingPage) {
                        return _c(
                          "a",
                          {
                            key: landingPage.id,
                            staticClass: "d-block small font-weight-light",
                            class: {
                              active:
                                _vm.activeSlug === "/nl/" + landingPage.slug
                            },
                            attrs: { href: "/nl/" + landingPage.slug }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.trimDot(landingPage.title.rendered))
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ]
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.isMobile && _vm.show
        ? _c(
            "div",
            { staticClass: "mobile-dropdown-menu mt-24" },
            _vm._l(_vm.visibleLandingPages, function(landingPage) {
              return _c(
                "a",
                {
                  key: landingPage.id,
                  staticClass: "d-block mb-24",
                  class: {
                    "font-weight-normal":
                      _vm.activeSlug === "/nl/" + landingPage.slug,
                    "font-weight-light":
                      _vm.activeSlug !== "/nl/" + landingPage.slug
                  },
                  attrs: { href: "/nl/" + landingPage.slug }
                },
                [_vm._v(_vm._s(_vm.trimDot(landingPage.title.rendered)))]
              )
            }),
            0
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }